import { Amplify } from 'aws-amplify';

type AuthConfig = {
  userPoolId: string;
  userPoolClientId: string;
  domain: string; // no https://
  redirectSignIn: string[];
  redirectSignOut: string[];
};

const AUTH_CONFIG_BY_HOST: Record<string, AuthConfig> = {
  localhost: {
    userPoolId: 'us-west-2_OErL4koUM',
    userPoolClientId: '79kfkjubo1nlnif3p025ipq5op',
    domain: 'auth.property.lab.seladorai.com',
    redirectSignIn: ['http://localhost:3000/auth/callback'],
    redirectSignOut: ['http://localhost:3000/'],
  },
  'property.lab.seladorai.com': {
    userPoolId: 'us-west-2_OErL4koUM',
    userPoolClientId: '79kfkjubo1nlnif3p025ipq5op',
    domain: 'auth.property.lab.seladorai.com',
    redirectSignIn: ['https://property.lab.seladorai.com/auth/callback'],
    redirectSignOut: ['https://property.lab.seladorai.com/'],
  },
};

function getAuthConfigForHost(): AuthConfig | null {
  const host = window.location.hostname;
  if (AUTH_CONFIG_BY_HOST[host]) {
    return AUTH_CONFIG_BY_HOST[host];
  }

  if (host === '127.0.0.1') {
    return AUTH_CONFIG_BY_HOST.localhost;
  }

  return null;
}

const selectedConfig = getAuthConfigForHost();

export const isAmplifyAuthConfigured = Boolean(selectedConfig);

if (selectedConfig) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: selectedConfig.userPoolId,
        userPoolClientId: selectedConfig.userPoolClientId,
        loginWith: {
          oauth: {
            domain: selectedConfig.domain,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: selectedConfig.redirectSignIn,
            redirectSignOut: selectedConfig.redirectSignOut,
            responseType: 'code',
          },
        },
      },
    },
  });
} else {
  console.warn(`Amplify Auth is not configured for hostname: ${window.location.hostname}`);
}
